const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgroIconBrown9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.94 47.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.02,6.89C42.26,1.13,34.14-1.05,26.62.47c-6.73.54-15.09,5.09-19.77,9.76-9.16,9.21-9.16,18.19.06,27.4,5.58,5.58,16.13,10.67,23.52,9.58,6.37.24,12.79-2.06,17.64-6.91,9.15-9.16,9.15-24.19-.06-33.41Zm-1.76,31.65c-8.25,8.25-21.58,8.25-29.83,0-8.25-8.25-8.25-21.58,0-29.83C24.69.47,38.02.47,46.27,8.71c8.18,8.24,8.18,21.58,0,29.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.08,20.9c.97.97,6.61-1.52,9.82-4.79,3.21-3.21,1.82-4.85.79-5.88-.97-.97-2.61-2.42-5.88.79-3.15,3.27-5.7,8.85-4.73,9.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.56,26.35c-.97-.97-6.61,1.52-9.82,4.79-3.21,3.21-1.82,4.85-.79,5.88.97.97,2.61,2.43,5.88-.79,3.21-3.27,5.76-8.85,4.73-9.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.56,20.9c.97-.97-1.52-6.61-4.79-9.82-3.21-3.21-4.85-1.82-5.88-.79-.97.97-2.43,2.61.79,5.88,3.27,3.15,8.91,5.7,9.88,4.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.08,26.35c-.97.97,1.52,6.61,4.79,9.82,3.21,3.21,4.85,1.82,5.88.79,1.03-1.03,2.43-2.61-.79-5.88-3.27-3.15-8.85-5.7-9.88-4.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.41,23.63c0-1.39-5.76-3.58-10.37-3.58s-4.73,2.18-4.73,3.58.12,3.58,4.73,3.58c4.67,0,10.37-2.18,10.37-3.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.54,20.05c-4.61,0-10.37,2.18-10.37,3.58s5.76,3.58,10.37,3.58,4.73-2.18,4.73-3.58-.12-3.58-4.73-3.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.35,27.51c-1.4,0-3.58,5.76-3.58,10.37s2.18,4.73,3.58,4.73,3.58-.12,3.58-4.73c0-4.61-2.18-10.37-3.58-10.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.35,19.75c1.39,0,3.58-5.76,3.58-10.37s-2.18-4.73-3.58-4.73-3.58.12-3.58,4.73,2.12,10.37,3.58,10.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.11,23.63c0,2.34-3.52,2.34-3.52,0s3.52-2.34,3.52,0",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroIconBrown9);
export default __webpack_public_path__ + "static/media/agro-icon-brown-9.b1498f5d8179284a913bbd6e30d54f97.svg";
export { ForwardRef as ReactComponent };